export interface Faq {
  id: string;
  question: string;
  answer: string;
}

export const faqs: Faq[] = [
  {
    id: 'faq-1',
    question: '职镜观察的内容从哪里来？',
    answer:
      '内容主要来自三个方向：一是可公开查证的企业信息，例如公开的股权变更、任职记录与官方公告；二是员工自愿投稿的一线经历；三是围绕制度文本与常见案例的整理分析。每条观察都会标注线索来源类别与核实时间，方便你判断可信度。',
  },
  {
    id: 'faq-2',
    question: '投稿之后我的身份会被公开吗？',
    answer:
      '不会。投稿内容在整理发布前会做脱敏处理，包括去除姓名、工号、具体部门、联系方式等可以指向个人的信息，只保留与公共讨论相关的部分。你也可以在投稿时注明哪些细节不希望被提及。',
  },
  {
    id: 'faq-3',
    question: '如果我发现某条观察与事实不符，可以要求更正吗？',
    answer:
      '可以。我们为企业与当事方保留了回应通道。你可以通过联系页面提交说明与佐证材料，核实后我们会在原条目中补充更正说明，并标注更新时间，不会静默删除争议内容。',
  },
  {
    id: 'faq-4',
    question: '网站上的薪资与补偿数字是准确的吗？',
    answer:
      '薪资相关内容多为投稿者提供的区间或个案，会受到岗位、城市、职级的显著影响，我们不保证适用于所有情况。建议把数字当作参考区间，并结合当地劳动法规与自身合同条款进行判断。',
  },
  {
    id: 'faq-5',
    question: '遇到薪资纠纷，第一步应该做什么？',
    answer:
      '先固定证据，再沟通，最后才是仲裁。具体来说，及时保存劳动合同、工资条、考勤记录、沟通聊天记录与转账凭证；随后以书面形式向公司提出诉求并保留送达证明；如果协商无果，可在法定时效内申请劳动仲裁。相关内容栏目里有更详细的操作拆解。',
  },
  {
    id: 'faq-6',
    question: '被通知裁员时，有哪些话术需要格外注意？',
    answer:
      '要留意“自愿离职”“个人原因”“协商一致”这类表述，它们会直接影响你能否获得经济补偿。在未看清书面文件、未确认补偿方案之前，不建议签署任何标注为自愿离职的材料，也不建议口头同意。',
  },
  {
    id: 'faq-7',
    question: '试用期被辞退，公司需要给补偿吗？',
    answer:
      '这取决于辞退理由与举证责任。如果公司以不符合录用条件为由解除合同，需要证明录用条件已提前明确告知且有客观考核依据；若无法证明，解除可能被认定为违法，需承担相应赔偿。建议保留岗位说明与考核记录。',
  },
  {
    id: 'faq-8',
    question: '网站会接广告或者替某家公司说好话吗？',
    answer:
      '不会。职镜观察不承接企业付费的正面公关内容，也不以删帖、下沉作为商业化方式。运营成本来自团队自筹与少量读者的自愿支持，这保证观察结论不会因为商业关系而改变。',
  },
];